export const SET_IS_CONNECTED = 'SET_IS_CONNECTED';
export const SET_CHAIN_ID = 'SET_CHAIN_ID';
export const SET_IS_ON_CORRECT_CHAIN = 'SET_IS_ON_CORRECT_CHAIN';
export const SET_CURRENT_WEB3_PROVIDER = 'SET_CURRENT_WEB3_PROVIDER';
